import { render, staticRenderFns } from "./GlLevel2CheckersQueue.vue?vue&type=template&id=e87d9d62&"
import script from "./GlLevel2CheckersQueue.vue?vue&type=script&lang=js&"
export * from "./GlLevel2CheckersQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports